import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { Group } from '../types';

interface GroupStore {
  groups: Group[];
  selectedGroup: Group | null;
  setSelectedGroup: (group: Group | null) => void;
  addGroup: (group: Group) => void;
  updateGroup: (id: string, updates: Partial<Group>) => void;
  addClinicianToGroup: (groupId: string, clinicianId: string) => void;
  removeClinicianFromGroup: (groupId: string, clinicianId: string) => void;
}

export const useGroupStore = create<GroupStore>()(
  persist(
    (set) => ({
      groups: [],
      selectedGroup: null,
      setSelectedGroup: (group) => set({ selectedGroup: group }),
      addGroup: (group) =>
        set((state) => ({ groups: [...state.groups, group] })),
      updateGroup: (id, updates) =>
        set((state) => ({
          groups: state.groups.map((g) =>
            g.id === id ? { ...g, ...updates } : g
          ),
        })),
      addClinicianToGroup: (groupId, clinicianId) =>
        set((state) => ({
          groups: state.groups.map((g) =>
            g.id === groupId
              ? { ...g, clinicians: [...g.clinicians, clinicianId] }
              : g
          ),
        })),
      removeClinicianFromGroup: (groupId, clinicianId) =>
        set((state) => ({
          groups: state.groups.map((g) =>
            g.id === groupId
              ? { ...g, clinicians: g.clinicians.filter((id) => id !== clinicianId) }
              : g
          ),
        })),
    }),
    {
      name: 'group-storage',
      partialize: (state) => ({
        groups: state.groups,
        // We don't persist selectedGroup as it's UI state
      }),
    }
  )
);